import React, { useCallback } from 'react';
import { MainLayout } from 'src/components';
import styles from './CreateWorkspacePage.module.scss';
import InfoTextBlock from 'src/atoms/InfoTextBlock/InfoTextBlock';

import { useDispatch } from 'react-redux';
import { addWorkspace } from 'src/redux/actions/workspacesActions';
import { PAGES } from 'src/constants/pages';
import { useHistory } from 'react-router-dom';
import WorkspaceFields from 'src/components/workspaces-components/WorkspaceFields';
import { workspaceNameCreateInitialValues, workspaceNameFields } from 'src/constants/workspacesConstants';
import { workspaceNameValidationSchema } from 'src/helpers/workspacesHelpers';

const CreateWorkspacePage = (): JSX.Element => {
  const dispatch = useDispatch();
  const { push } = useHistory();

  const [requestError, setRequestError] = React.useState<null | { message: string }>(null);

  const onSubmit = useCallback(
    (values: { name: string }) => {
      const payload = {
        body: { name: values?.name || '' },
        onSuccess: () => {
          push(PAGES.WORKSPACES_MANAGEMENT);
        },
        onError: (error) => {
          setRequestError(
            error?.message ? { message: error.message } : { message: 'Something went wrong. Please try again.' }
          );
        }
      };

      setRequestError(null);

      dispatch(addWorkspace(payload));
    },
    [dispatch, push]
  );

  return (
    <MainLayout isCentered isPrivate={false} isFixedHeader>
      <div className={styles.container}>
        <div className={styles.contentWrapper}>
          <h1 className={styles.title}> Create Your first Workspace</h1>

          <div className={styles.divider} />

          <InfoTextBlock classes={{ wrapper: styles.descriptionWrapper }}>
            A Workspace is an environment where users can create, organize, and manage portfolio allocations. It also
            enables collaboration by allowing you to grant specific access rights, such as view or edit, to other users.
            <br />
            You need a workspace to start working with Loansweeper. <br />
            <br /> You can edit, delete this one or create a new workspace later.
          </InfoTextBlock>

          <WorkspaceFields
            onSubmit={onSubmit}
            initialValues={workspaceNameCreateInitialValues}
            schema={workspaceNameValidationSchema}
            fileds={workspaceNameFields}
            requestError={requestError}
          />
        </div>
      </div>
    </MainLayout>
  );
};

export default CreateWorkspacePage;
